import React from 'react';

import PropTypes from 'prop-types';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

export type MenuGroupHeaderProps = StylableComponent<HTMLParagraphElement>;

const MenuGroupHeader = ({
  className,
  style,
  children,
  ...props
}: MenuGroupHeaderProps) => {
  return (
    <p
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          margin: 0,
          paddingLeft: 16,
          height: 32,
          background: theme.colors.charcoal050,
          color: 'inherit',
        },
        theme.typography.bodySmall,
        style,
      ]}
      {...props}
    >
      {children}
    </p>
  );
};

MenuGroupHeader.displayName = 'MenuGroupHeader';

MenuGroupHeader.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Group Header content */
  children: PropTypes.node,
};

export default MenuGroupHeader;
